<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-1">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                            {{$t('button.back')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5 ml-n1"
                >

                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisecode')"
                                    ref="kpiexercode"
                                    readonly
                                    v-model="formData.kpiexercode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisedesc')"
                                    ref="kpiexerdesc"
                                    readonly
                                    v-model="formData.kpiexerdesc"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.status')"
                                    ref="kpiexerstatus"
                                    readonly
                                    v-model="formData.kpiexerstatus"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="2" sm="2" class="mt-n6 mb-4">
                                <v-text-field
                                    class="big-field"
                                    outlined
                                    :label="$t('pmreviewexercise.recordsgenerated')"
                                    ref="totalRecords"
                                    readonly
                                    v-model="formData.totalRecords"
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-container>
                    <div>
                        <v-row>
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.filteredTabHeader,
                                    detailItem: this.staffList,
                                    isWizard: this.parentObject.isWizard
                                }"
                            />
                        </v-row>
                    </div>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="closeHandler" 
                            > 
                             {{$t('button.close')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableStaff';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
        "app-error": ErrorDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            formData: {
                kpiexerid: this.parentObject.data.kpiexerid,
                kpiexercode: this.parentObject.data.kpiexercode,
                kpiexerdesc: this.parentObject.data.kpiexerdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                kpiexerstatusid: this.parentObject.data.kpiexerstatusid,
                kpiexerstatus: this.parentObject.data.kpiexerstatus,
                wfroleid: this.parentObject.data.wfroleid,
                wfrolecode: this.parentObject.data.wfrolecode,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
                totalRecords: this.parentObject.data.totalRecords,
            },

            formDataParameter: this.$route.params.formDataParameter,
            parameters: this.$route.params.parameters,      
            staffList: this.parentObject.staffList,   

            errMsg: "",
            isErr: false,


            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '80px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffcode', width: '120px', sortable: true},
                { text: this.$t('columns.name'), value: 'staffname', width: '180px', sortable: true},
                { text: this.$t('appraisalrecord.reviewer'), value: 'reviewercode', width: '120px', sortable: true},
                { text: this.$t('appraisalrecord.reviewername'), value: 'reviewername', width: '180px', sortable: true},
                { text: this.$t('columns.startdate'), value: 'periodstartdate', width: '120px', sortable: true},
                { text: this.$t('columns.enddate'), value: 'periodenddate', width: '120px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '100px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '100px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '100px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '100px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '100px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '100px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '100px', sortable: true},
                { text: this.$t('performancemanagement.createddate'), value: 'createdate', width: '120px', sortable: true},
                { text: this.$t('performancemanagement.completeddate'), value: 'completedate', width: '120px', sortable: true},
            ],
        }
    },

    computed: {
        filteredTabHeader() {
            if (this.parentObject.isWizard) {
                return this.tabHeader.filter(item => item.value !== 'action');
            } else {
                return this.tabHeader;
            }
        },

        totalRecord() {
            return this.staffList.length;
        }
    },

    methods: {

        closeHandler() {
            this.$router.push({name: 'kpisettinglist'});
        },

        backHandler(){
            this.$router.push({name: 'kpisettinggenerate', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters}});
        },

        // async createKpiExercise() {

        //     // if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        //     //     return false;
        //     // }

        //     const vm = this;

        //     const payload = {
        //         formData: vm.formData,
        //         formDataParameter: vm.formDataParameter,
        //         parameters: vm.parameters,
        //         staffList: vm.staffList,
        //         userid: this.parentObject.data.userid,
        //         stamp: this.parentObject.data.stamp,
        //     }

        //     await this.$store.dispatch('post', {url: "/kpiexercise/create", payload: payload})
        //     .then((res) => {
        //         if (res.data.error) {
        //             vm.isErr = !vm.isErr;
        //             vm.errMsg = res.data.error;
        //         } else {
        //             this.$router.push({name: 'kpisettinglist'});
        //         }
        //     })
        //     .catch((err) => {
        //         vm.isErr = !vm.isErr;
        //         vm.errMsg = err;
        //     });
        // },

    },

    async created() {
    }
}
</script>

<style scoped>
::v-deep .big-field .v-text-field__slot input {
    font-size:18px;
    font-weight:bold;
}

::v-deep .big-field .v-label {
    font-size:20px;
}
</style>
